import { useCompConfig } from "@/context/CompConfigContext";
import LichThiDauKQV4 from "../LichThiDauKQV4";
import { buildThemeStyle } from "../KbvTiLeV25/buildThemeStyle";

const KbvLichThiDauV4 = () => {
  const compConfig = useCompConfig();
  const { hasDataConfig } = compConfig;
  const themeStyle = buildThemeStyle(compConfig, hasDataConfig);

  return <LichThiDauKQV4 themeStyle={themeStyle} />;
};

export default KbvLichThiDauV4;
